module.exports = __webpack_public_path__ + "img/emoji-dollars-240x240.69b4a5cb.png";